import Tab from '@mui/material/Tab';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';
import { Link } from 'react-router-dom';

export interface LinkTabProps {
  /** The label to display on the tab */
  label: string;
  /** The value for the tab (used for tab selection state) */
  value: string;
  /** Whether the tab is disabled */
  disabled?: boolean;
  /** Custom styles for the Tab */
  sx?: SxProps<Theme>;
  /** Icon for the tab */
  icon?: React.ReactElement;
  /** Icon position */
  iconPosition?: 'top' | 'bottom' | 'start' | 'end';
  /** Additional aria properties for accessibility */
  id?: string;
  'aria-controls'?: string;
  /** The path/URL to navigate to */
  to: string;
}

// Helper function to generate standard tab props for accessibility
export const getTabProps = (name: string) => {
  return {
    id: `simple-tab-${name}`,
    'aria-controls': `simple-tabpanel-${name}`,
  };
};

export const LinkTab: React.FC<LinkTabProps> = ({
  label,
  value,
  disabled = false,
  sx,
  icon,
  iconPosition = 'top',
  id,
  'aria-controls': ariaControls,
  to,
  ...rest
}) => {
  return (
    <Tab
      component={Link}
      to={to}
      label={label}
      value={value}
      disabled={disabled}
      sx={sx}
      icon={icon}
      iconPosition={iconPosition}
      id={id}
      aria-controls={ariaControls}
      {...rest}
    />
  );
};

export default LinkTab;
